import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import VM from 'scratch-vm';

import Box from '../../../components/box/box.jsx';
import {STAGE_DISPLAY_SIZES} from '../../../lib/layout-constants.js';
import StageHeader from '../../../containers/stage-header.jsx';
import Stage from '../../../containers/stage.jsx';
import Loader from '../../../components/loader/loader.jsx';
import {getStageDimensions} from '../../../lib/screen-utils.js';

import styles from './stage-player.css';

const StageWrapperComponent = function(props) {
    const {
        isFullScreen,
        isRtl,
        isRendererSupported,
        loading,
        stageSize,
        vm
    } = props;
    const stageDimensions = getStageDimensions(stageSize, isFullScreen);

    return (
        <Box
            className={classNames(
                styles.stageWrapper,
                {[styles.fullScreen]: isFullScreen}
            )}
            dir={isRtl ? 'rtl' : 'ltr'}
        >
            <Box className={styles.stageMenuWrapper}>
                <StageHeader
                    stageSize={stageSize}
                    vm={vm}
                />
            </Box>
            <Box className={styles.stageCanvasWrapper} style={{ width: !isFullScreen ? '100%' : stageDimensions.height * 4 / 3 }}>
                {
                    isRendererSupported ?
                        <Stage
                            stageSize={stageSize}
                            vm={vm}
                        /> :
                        null
                }
                {loading ? (
                    <Loader isFullScreen={isFullScreen} type={'share'} />
                ) : null}
            </Box>
        </Box>
    );
};

StageWrapperComponent.propTypes = {
    isFullScreen: PropTypes.bool,
    isRendererSupported: PropTypes.bool.isRequired,
    isRtl: PropTypes.bool.isRequired,
    loading: PropTypes.bool,
    stageSize: PropTypes.oneOf(Object.keys(STAGE_DISPLAY_SIZES)).isRequired,
    vm: PropTypes.instanceOf(VM).isRequired
};

export default StageWrapperComponent;
